export default __webpack_public_path__ + "static/media/hero-mockup-transparent.9c6a502e.png";